import React from 'react';
import PublicShell from './PublicShell';
import { useJsonApi } from './useJsonApi';
import PriorityCard from './PriorityCard';
import LineMedicSections from './LineMedicSections';
export default function LineMedicPublic(){
 const api=useJsonApi('/api/line-medic');
 const data=api.data||{};
 return <PublicShell title="Line Medic Program Availability" subtitle="Program availability" freshness={data.generatedAt||''}>
  {api.error&&<div className="pub-error">{api.error}</div>}
  <PriorityCard data={data} refresh={api.refresh} loading={api.loading}/>
  <LineMedicSections data={data}/>
 </PublicShell>;
}
